<!-- src/views/PrivacyPolicy.vue -->
<template>
  <div class="privacy-container">
    <div class="privacy-content">
      <!-- 主标题 -->
      <h1 class="main-title">Privacy Policy</h1>
      <p class="effective-date">Effective Date: January 1, 2024</p>

      <!-- 政策内容区块 -->
      <div class="policy-section">
        <h2 class="section-title">1. Information Collection</h2>
        <div class="section-content">
          <p>We collect the following types of information:</p>
          <ul class="info-list">
            <li>
              <strong>Contact Information:</strong> Name, company, email, phone
              number provided through contact forms
            </li>
            <li>
              <strong>Technical Data:</strong> Equipment specifications,
              manufacturing requirements
            </li>
            <li>
              <strong>Usage Data:</strong> IP addresses, browser type, pages
              visited on yoleecorp.com
            </li>
          </ul>
        </div>
      </div>

      <div class="policy-section">
        <h2 class="section-title">2. Use of Information</h2>
        <div class="section-content">
          <p>Your information is used to:</p>
          <ul class="info-list">
            <li>Provide customized products & services solutions</li>
            <li>Process RFQ (Request for Quotation) submissions</li>
            <li>Deliver technical support services</li>
            <li>Improve industrial offerings</li>
          </ul>
        </div>
      </div>

      <div class="policy-section">
        <h2 class="section-title">3. Data Security</h2>
        <div class="section-content">
          <p>We implement enterprise-grade security measures:</p>
          <ul class="info-list">
            <li>256-bit SSL encryption for all data transmissions</li>
            <li>Industrial firewall protection systems</li>
            <li>Regular vulnerability scanning and penetration testing</li>
            <li>Access restricted to authorized personnel only</li>
          </ul>
        </div>
      </div>

      <div class="policy-section">
        <h2 class="section-title">4. Third-Party Disclosure</h2>
        <div class="section-content">
          <p>We do not share your information with third parties except:</p>
          <ul class="info-list">
            <li>Compliance with legal obligations</li>
            <li>
              Essential service providers under NDA (e.g., payment processors)
            </li>
            <li>Business transfers involving mergers/acquisitions</li>
          </ul>
        </div>
      </div>

      <div class="policy-section">
        <h2 class="section-title">5. Your Rights</h2>
        <div class="section-content">
          <ul class="info-list">
            <li>Request access to your personal data</li>
            <li>Correct inaccurate information</li>
            <li>Withdraw consent for data processing</li>
            <li>Request data deletion under GDPR guidelines</li>
          </ul>
          <p>
            Contact our Data Protection Officer at: <br />
            info@yoleecorp.com
          </p>
        </div>
      </div>

      <div class="policy-section">
        <h2 class="section-title">6. Policy Updates</h2>
        <div class="section-content">
          <p>
            We may update this policy periodically. Significant changes will be
            notified via:
          </p>
          <ul class="info-list">
            <li>Website banner notifications</li>
            <li>Registered email alerts</li>
            <li>Policy version tracking (Current version: 2.1)</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
  mounted() {
    this.$emit("set-product-page", true);
  },
  beforeDestroy() {
    this.$emit("set-product-page", false);
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/styles/variables.less";
@import "~@/assets/styles/mixins.less";

.privacy-container {
  max-width: 1200px;
  margin: 2rem auto;
  padding: 0 1rem;
}

.main-title {
  color: @color-text-title;
  font: 600 2.5rem/1.2 @font-en;
  text-align: center;
  margin-bottom: 1rem;
}

.effective-date {
  color: @color-text-sub;
  text-align: center;
  margin-bottom: 3rem;
  font-size: 0.9rem;
}

.policy-section {
  background: @color-bg-light;
  .cardRadius();
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 8px fade(@color-primary, 5%);

  .section-title {
    color: @color-primary;
    font: 600 1.5rem/1.3 @font-en;
    margin-bottom: 1rem;
    border-bottom: 2px solid fade(@color-primary, 20%);
    padding-bottom: 0.5rem;
  }

  .section-content {
    color: @color-text-content;
    line-height: 1.7;

    p {
      margin: 1rem 0;
    }
  }

  .info-list {
    margin: 1.5rem 0;
    padding-left: 1.5rem;

    li {
      margin-bottom: 0.8rem;
      position: relative;
      padding-left: 1.2rem;

      &::before {
        content: "•";
        color: @color-primary;
        position: absolute;
        left: 0;
      }

      strong {
        color: @color-text-title;
      }
    }
  }
}

.mobile-only({
  .privacy-container {
    padding: 0 0.5rem;
  }

  .policy-section {
    padding: 1.5rem;
    
    .section-title {
      font-size: 1.2rem;
    }
  }
});
</style>
